var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('button',_vm._g(_vm._b({on:{"click":_vm.onCopy}},'button',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_c('span',[_vm._v("Click to copy")])])
}
var staticRenderFns = []

export { render, staticRenderFns }